var simpleTable = function()
{
	var instance = {};
	
	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].data = component.data;
		scope[componentKey].config = component.config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		//initalise component properties
		var config = scope[componentKey].config;
		scope[componentKey] = {};
		scope[componentKey].data = resultComponentVal;
		scope[componentKey].instance = {};
		scope[componentKey].config = config
	};

	return instance;
};